import React, { FC } from 'react';

import styles from './styles.module.scss';

type Props = {
  openPhoneCallModal: () => void;
};

const FooterContacts: FC<Props> = ({ openPhoneCallModal }) => {
  return (
    <div className={`${styles.contactsBlock} container`}>
      <div className={styles.contactsItem}>
        <div className={styles.contactsTitle}>Есть вопросы? Звоните:</div>
        <a href="tel:+74958990909" onClick={openPhoneCallModal}>
          {' '}
          8 (495) 899-09-09{' '}
        </a>
        <div className={styles.contactsWorkTime}>работает с&nbsp;9:00 до&nbsp;18:00, пн.— пт.</div>
      </div>
      <div className={styles.contactsItem}>
        <div className={styles.contactsTitle}>Электронная почта</div>
        <a href="mailto:info@megaprom.ru" className={styles.contactsEmail}>
          info@megaprom.ru
        </a>
      </div>
    </div>
  );
};

export default FooterContacts;
